import { Helmet } from 'react-helmet-async';
import KeywordBased from 'src/sections/overview/dashboards/views/keywordBased';

export default function BrandShieldActiveMode() {
  return (
    <>
      <Helmet>
        <title>Active Mode</title>
      </Helmet>

      <KeywordBased />
    </>
  );
}
